export default "__VITE_ASSET__589c2e88__"